import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { Box, Button, Popover } from '@mui/material'
import React from 'react'
import Formatter from '../../helpers/Formatter'
import Helper from '../../helpers/Helper'
import TimeHelper from '../../helpers/TimeHelper'
import { useAppSelector } from '../../store/Hooks'
import Tile from '../layout/Tile'
import TimePopover from './TimePopover'

function TimeSelection() {
    const popoverWidth = 250
    const time = useAppSelector(s => s.app.timeSettings ?? TimeHelper.timeSettings())
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement>(null)
    const open = Helper.hasVal(anchorEl)

    const from = time.from && new Date(time.from)
    const to = time.to && new Date(time.to)

    return (
        <Tile.Tile>
            <Button
                startIcon={(
                    <Box display='flex' justifyContent='center' alignItems='center'>
                        <CalendarTodayIcon fontSize='small' />
                    </Box>
                )}
                aria-describedby='time-settings-popover'
                variant='contained'
                size='medium'
                onClick={event => setAnchorEl(event.currentTarget)}>
                {from ? Formatter.date(from) : '∞' } - {to ? Formatter.date(to) : '∞'}
            </Button>
            <Popover
                id='time-settings-popover'
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                style={{ marginTop: 10 }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <TimePopover width={popoverWidth} />
            </Popover>
        </Tile.Tile>
    )
}

export default TimeSelection
